module.exports = __webpack_public_path__ + "static/Commission_v2-opt-95d3590076519c3ab123c3359cbd4054.mp4";